


import { Component, Prop, Vue } from "vue-property-decorator";

import Icon from "Web/Components/Icon.vue";

/* L'APERCU D'UN BLOG, comme dans ses parametres au Desktop ( `Web/Views/Blogs/Preview.vue` ) :
   la page d'accueil du site du flux, dessinee a 1280 px puis reduite a la largeur du cadre.
   Le cadre ne se manipule pas ; un clic ouvre le blog. */
const SITE_WIDTH = 1280;

@Component({
    components: {
        Icon
    }
})
export default class NewsletterBlogPreview extends Vue {
    @Prop( { default: "" } )
    readonly FeedUrl!: string;

    private scale: number = 0;
    private siteWidth: number = SITE_WIDTH;
    private viewportHeight: number = 0;
    private observer: any = null;

    private get siteUrl(): string {
        try {
            const url = new URL( this.FeedUrl );

            const web = url.protocol === "http:" || url.protocol === "https:";

            return web ? url.origin + "/" : "";
        } catch( e ) {
            return "";
        }
    }

    private get host(): string {
        return this.siteUrl.replace( /^https?:\/\//, "" ).replace( /\/$/, "" );
    }

    private get frameStyle(): { [ key: string ]: string } {
        return {
            width: `${ this.siteWidth }px`,
            height: ( this.scale > 0 )
                ? `${ Math.ceil( this.viewportHeight / this.scale ) }px`
                : "100%",
            transform: `scale( ${ this.scale } )`
        };
    }

    mounted(): void {
        this.measure();

        const Observer = ( window as any ).ResizeObserver;

        if( Observer !== undefined && this.$refs.Viewport !== undefined ) {
            this.observer = new Observer( () => this.measure() );
            this.observer.observe( this.$refs.Viewport as Element );
        }
    }

    beforeDestroy(): void {
        if( this.observer !== null )
            this.observer.disconnect();
    }

    private measure(): void {
        const viewport = this.$refs.Viewport as HTMLElement | undefined;

        if( viewport === undefined )
            return;

        const width = viewport.clientWidth;

        this.viewportHeight = viewport.clientHeight;

        if( width <= 0 )
            return;

        this.siteWidth = Math.max( width, SITE_WIDTH );
        this.scale = width / this.siteWidth;
    }

    private open(): void {
        if( this.siteUrl !== "" )
            window.open( this.siteUrl, "_blank", "noopener" );
    }
}
